<template>
  <div class="border-b border-border-medium">
    <component :is="props.isSingleItem ? 'div' : 'button'" class="group flex w-full flex-col text-base" :title="props.option ? props.option.name : null">
      <div class="w-full pb-4" :class="{ 'group-hover:text-text-strong': !props.isSingleItem }">
        <div class="flex w-full items-center">
          <span class="truncate">
            <span class="font-medium">
              {{ t['w.module.options_section.choose']() }}
              <span class="lowercase">{{ title }}:&nbsp;</span>
            </span>
            <span v-if="props.option && !props.isTextOption" class="text-left font-semibold">{{ props.option.name || props.option.groupParameter }}</span>
          </span>
          <InfoTooltip v-if="props.description" class="ml-1">{{ props.description }}</InfoTooltip>
          <span v-if="!props.isSingleItem" class="ml-auto flex size-6 shrink-0 items-center justify-center rounded-full group-hover:bg-background-light">
            <Icon class="size-6 transition-colors" name="arrow-right" />
          </span>
        </div>
        <span v-if="props.isError" class="inline-block w-full text-left text-base text-text-attention"> Tee valik! </span>
      </div>
      <SingleTextSelection v-if="props.option && props.isTextOption" :option="props.option" :is-single-item="isSingleItem" />
      <SingleImageSelection v-if="props.option && props.isImageOption" :option="props.option" hide-title :is-single-item="isSingleItem" />
      <SingleColorSelection v-if="props.option && props.isColorOption" :option="props.option" hide-title :is-single-item="isSingleItem" />
    </component>
  </div>
</template>

<script setup lang="ts">
import InfoTooltip from '~/components/info-tooltip/InfoTooltip.vue'
import SingleImageSelection from './SingleImageSelection.vue'
import SingleColorSelection from './SingleColorSelection.vue'
import SingleTextSelection from './SingleTextSelection.vue'
import * as t from '~/messages'

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
  option: {
    type: Object,
    default: null,
  },
  isSingleItem: {
    type: Boolean,
    default: false,
  },
  isTextOption: {
    type: Boolean,
    default: false,
  },
  isImageOption: {
    type: Boolean,
    default: false,
  },
  isColorOption: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
})
</script>
